module.exports = __webpack_public_path__ + "static/a.ballard-15f1850f0f748e4bfd14ee05ba661418.jpg";